// Dependencies
import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../models/organization.model';

// Interfaces
import { OrganizationSelectionI } from '../../interfaces/organization-selection.interface';

@Component({
    selector: 'organization-selection-form',
    templateUrl: './organization-selection-form.component.html',
    styleUrls: ['./organization-selection-form.component.scss']
})
export class OrganizationSelectionFormComponent {
    constructor() {}

    // Bindings
    @Input() organizationId: number;
    @Input() organizationList: OrganizationModel[];
    @Input() respondentRoleList: Object[];
    @Input() studySlug: string;
    @Output() continueClicked = new EventEmitter<OrganizationSelectionI[]>();

    // Properties
    organizationsSelected: OrganizationSelectionI[] = [];
    organizationsSelectedIds: number[] = [];

    //---------------------------------
    // Lifecycle Hooks
    //---------------------------------

    ngOnInit() {
        // Initialize organization selections by adding the 1st row
        let organizationRow: OrganizationSelectionI = { organization: null, respondentRole: null };
        this.organizationsSelected.push(organizationRow);

        // If organization was passed as a query param, automatically select that organization
        if (this.organizationId) {
            const foundOrganization = this.organizationList.find(organization => Number(organization.id) === this.organizationId);
            if (foundOrganization) {
                this.organizationsSelected[0].organization = foundOrganization;
                this._setOrganizationsToExclude();
            }
        }
    }


    //---------------------------------
    // Public
    //---------------------------------

    addOrganizationRow() {
        let newRow: OrganizationSelectionI = {
            organization: null,
            respondentRole: null
        };

        this.organizationsSelected.push(newRow);
    }

    continue() {
        this.continueClicked.emit(this.organizationsSelected);
    }

    downloadParticipatingOrgs() {
        // Compile content
        let csvContent = "data:text/csv;charset=utf-8,";
        this.organizationList.forEach(organization => {
            csvContent += `"${organization.getOrganizationName(true)}"\r\n`;
        });

        // Download file
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "organizations.csv");
        document.body.appendChild(link); // Required for FF

        link.click();
    }

    getIsFormValid() {
        return this.organizationsSelected.length > 0 
            && this.organizationsSelected.every( (org:any) => org.organization);
        //return this.getIsOrganizationValid(0)
          //  && this.getIsOrganizationValid(1)
            // && this.getIsOrganizationValid(2);
    }

    getIsOrganizationValid(index) {
        if (_.isUndefined(this.organizationsSelected[index])) {
            return true;
        }

        const orgSelected = this.organizationsSelected[index];
        return orgSelected
            && orgSelected.organization !== null;
            // && (orgSelected.respondentRole || '').length > 0;
    }

    getOrganizationSelected(index) {
        if (this.organizationsSelected[index] && this.organizationsSelected[index].organization) {
            return this.organizationsSelected[index].organization;
        } else {
            return null;
        }
    }

    removeOrganizationRow(index) {
        this.organizationsSelected.splice(index, index + 1);
    }

    setOrganization(organization, index) {
        if (this.organizationsSelected.length < index + 1) {
            let newRow: OrganizationSelectionI = {
                organization,
                respondentRole: null
            };

            this.organizationsSelected.push(newRow);
        } else {
            _.set(this.organizationsSelected[index], 'organization', organization);
        }

        this._setOrganizationsToExclude();
    }

    setRespondentRole(respondentRole, index) {
        if (this.organizationsSelected.length < index + 1) {
            this.organizationsSelected.push({
                organization: null,
                respondentRole
            })
        } else {
            _.set(this.organizationsSelected[index], 'respondentRole', respondentRole);
        }
    }

    viewParticipatingOrgs() {
        let redirectUrl = `/${this.studySlug}/organizations`;
        window.open(redirectUrl);
    }


    //----------------------------------
    // Private
    //----------------------------------

    private _setOrganizationsToExclude() {
        this.organizationsSelectedIds = this.organizationsSelected.map(orgObj => orgObj.organization ? Number(orgObj.organization.id) : null);
    }
}


// WEBPACK FOOTER //
// ./src/app/partials/organization-selection-form/organization-selection-form.component.ts